import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Timer10SelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timer_10_select"}/>
}
